export default {"src":"/_next/static/media/instagram_black.b351d90c.svg","height":49,"width":49};